@if (favoriteProductCount>0) {
  <button
    mat-icon-button
    (click)="goToCartCheckout()"
    matBadgeColor=accent
    >
    <img alt="" src="assets/icons/favorite-24px.svg"
      class="favorite-24px">
  </button>
} @else {
  <button mat-icon-button   (click)="goToCartCheckout()">
    <img alt="" src="assets/icons/favorite-24px-grey.svg"
      class="favorite-24px">
  </button>
}
